import {
  startOfWeek,
  endOfWeek,
  subWeeks,
  subMonths,
  subDays,
  startOfDay,
  endOfDay,
  startOfMonth,
  endOfMonth,
  startOfQuarter,
  endOfQuarter,
  startOfYear,
  endOfYear,
} from "date-fns";
import { Shortcut } from "../@types";

export const SERVICES = [
  { value: "Invoice", label: "Invoice" },
  { value: "Expense", label: "Expense" },
  { value: "Customer", label: "Customer Name" },
  { value: "Settings", label: "Settings" },
  { value: "SideBar", label: "SideBar" },
];

export const TODAY = {
  date: new Date(),
  label: "Today",
};

export const defaultShortcuts: Shortcut[] = [
  {
    label: "Today",
    range: () => [startOfDay(new Date()), endOfDay(new Date())],
  },
  {
    label: "This Week",
    range: () => [
      startOfWeek(new Date(), { weekStartsOn: 1 }),
      endOfWeek(new Date(), { weekStartsOn: 1 }),
    ],
  },
  {
    label: "Last Week",
    range: () => {
      const lastWeek = subWeeks(new Date(), 1);
      return [
        startOfWeek(lastWeek, { weekStartsOn: 1 }),
        endOfWeek(lastWeek, { weekStartsOn: 1 }),
      ];
    },
  },
  {
    label: "Last Month",
    range: () => {
      const today = new Date();
      const firstDayOfLastMonth = startOfMonth(subMonths(today, 1));
      const lastDayOfLastMonth = endOfMonth(subMonths(today, 1));
      return [firstDayOfLastMonth, lastDayOfLastMonth];
    },
  },
  {
    label: "Last 90 Days",
    range: () => [startOfDay(subDays(new Date(), 90)), endOfDay(new Date())],
  },
];

export const dashboardDefaultShortcuts: Shortcut[] = [
  {
    label: "Yesterday",
    range: () => {
      const yesterday = subDays(new Date(), 1);
      return [startOfDay(yesterday), endOfDay(yesterday)];
    },
  },
  {
    label: "Last 7 days",
    range: () => {
      const today = new Date();
      const sevenDaysAgo = subDays(today, 6); // Includes today
      return [startOfDay(sevenDaysAgo), endOfDay(today)];
    },
  },
  {
    label: "This Week",
    range: () => [
      startOfWeek(new Date(), { weekStartsOn: 1 }),
      endOfWeek(new Date(), { weekStartsOn: 1 }),
    ],
  },
  {
    label: "Last Week",
    range: () => {
      const lastWeek = subWeeks(new Date(), 1);
      return [
        startOfWeek(lastWeek, { weekStartsOn: 1 }),
        endOfWeek(lastWeek, { weekStartsOn: 1 }),
      ];
    },
  },
  {
    label: "Last Month",
    range: () => {
      const today = new Date();
      const firstDayOfLastMonth = startOfMonth(subMonths(today, 1));
      const lastDayOfLastMonth = endOfMonth(subMonths(today, 1));
      return [firstDayOfLastMonth, lastDayOfLastMonth];
    },
  },
  {
    label: "Last 30 Days",
    range: () => [startOfDay(subDays(new Date(), 30)), endOfDay(new Date())],
  },

  {
    label: "Last 60 Days",
    range: () => [startOfDay(subDays(new Date(), 60)), endOfDay(new Date())],
  },
  {
    label: "Last 90 Days",
    range: () => [startOfDay(subDays(new Date(), 90)), endOfDay(new Date())],
  },
  {
    label: "This Quarter",
    range: () => [startOfQuarter(new Date()), endOfQuarter(new Date())],
  },
  {
    label: "Last 365 Days",
    range: () => [startOfDay(subDays(new Date(), 365)), endOfDay(new Date())],
  },
  // {
  //   label: "Fiscal Year",
  //   range: () => [startOfYear(new Date()), endOfYear(new Date())],
  // },
];
